import React from 'react';
import { FiStar } from 'react-icons/fi';

const TestimonialCard = ({ testimonial }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm border">
    <div className="flex items-center gap-3 mb-3">
      <img src={`https://i.pravatar.cc/150?u=${testimonial.name.replace(' ', '_')}`} alt={testimonial.name} className="w-12 h-12 rounded-full" />
      <div>
        <p className="font-bold text-gray-800">{testimonial.name}</p>
        <p className="text-xs text-gray-500">{testimonial.role}</p>
      </div>
    </div>
    <div className="flex items-center gap-1 mb-3">
      {[...Array(5)].map((_, i) => (
        <FiStar key={i} className={`${i < testimonial.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />
      ))}
    </div>
    <p className="text-gray-600 text-sm italic">"{testimonial.text}"</p>
  </div>
);

export default TestimonialCard;
